import {CompilationTargetId} from "../../../types/CompilationTargetId";
import {NodeImplChunk} from "../../chunks/types/NodeImplChunk";

export function getTargetIdFromNodeImplChunk(
  nodeImplChunk: NodeImplChunk
): CompilationTargetId | null {
  const {
    captures: {
      1: builtinTargetChunk,
      2: runtimeChunk
    }
  } = nodeImplChunk;
  return builtinTargetChunk && builtinTargetChunk.captures[0] as CompilationTargetId
    || runtimeChunk && runtimeChunk.captures[0] as CompilationTargetId;
}
